// ShotClock24.jsx
import React from "react";
import {
    Paper,
    IconButton,
    Typography,
    makeStyles,
    Grid
} from "@material-ui/core";

import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import PauseIcon from "@material-ui/icons/Pause";
import ReplayIcon from "@material-ui/icons/Replay";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";

import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 5,

        color: "#fff",
        display: "flex",
        alignItems: "center"
    },
    leftSide: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginRight: theme.spacing(1.5)
    },
    timeDisplay: {
        fontSize: "4rem",
        fontWeight: "bold",
        lineHeight: 1
    },
    warning: {
        animation: "$pulse 0.7s ease-in-out infinite"
    },
    "@keyframes pulse": {
        "0%": { transform: "scale(1)", opacity: 1 },
        "50%": { transform: "scale(1.1)", opacity: 0.5 },
        "100%": { transform: "scale(1)", opacity: 1 }
    },
    plusMinusRow: {
        marginTop: theme.spacing(0.5),
        display: "flex",
        justifyContent: "center"
    },
    rightPanel: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(0.5)
    },
    iconButton: {
        backgroundColor: "#222",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#444"
        },
        padding: "10px 20px",
        margin: 2,
        fontSize: "1.4rem",
        minHeight: "64px"
    },
    smallIconButton: {
        backgroundColor: "#222",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#444"
        },
        margin: theme.spacing(0, 0.5),
        padding: 4
    }
}));

/**
 * Props:
 * - remaining (number)
 * - running (bool)
 * - onPlay()
 * - onPause()
 * - onReset()
 * - onAdd()
 * - onRemove()
 */
const ShotClock24 = ({
    remaining,
    running,
    onPlay,
    onPause,
    onReset,
    onAdd,
    onRemove
}) => {
    const classes = useStyles();

    return (
        <Grid container spacing={2} alignItems="center">


            <Grid item xs={4} sm={4}>
                <Grid container spacing={1} alignItems="center">
                    <Grid item xs={12} sm={12}>


                        <Typography style={{ fontFamily: "Digital" }}
                            className={clsx(
                                classes.timeDisplay,
                                remaining <= 5 && remaining > 0 && classes.warning
                            )}
                        >
                            {remaining.toString().padStart(2, "0")}

                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <div className={classes.plusMinusRow}>
                            <IconButton
                                onClick={onRemove}
                                disabled={remaining === 0}
                                className={classes.smallIconButton}
                            >
                                <RemoveIcon />
                            </IconButton>
                            <IconButton
                                onClick={onAdd}
                                disabled={remaining === 24}
                                className={classes.smallIconButton}
                            >
                                <AddIcon />
                            </IconButton>

                        </div>
                    </Grid>
                </Grid>
            </Grid>

            {/* LADO DERECHO: play / pause / reset en columna */}
            <Grid item xs={8} sm={8}>

                <IconButton
                    onClick={onPlay}
                    //disabled={running}
                    className={classes.iconButton}
                >
                    <PlayArrowIcon />
                </IconButton>

                <IconButton
                    onClick={onPause}
                    //disabled={!running}
                    className={classes.iconButton}
                >
                    <PauseIcon />
                </IconButton>
                <IconButton
                    onClick={onReset}
                    className={classes.iconButton}
                >
                    <ReplayIcon />
                </IconButton>

            </Grid>
        </Grid >
    );
};

export default ShotClock24;
